export type ColumnWorkItemState = {
  [id: string]: string[]
};

export const initialState: ColumnWorkItemState = {} as ColumnWorkItemState;
